import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { returnPathSearchParam } from '@/lib/return-path';

// /auth/login — the retired standalone sign-in page. Sign-in lives on the Join
// landing (`/sign-in`); this path stays only as a redirect there because it is
// already out in the world (bookmarks, browser history, previously shared
// sign-in links). Every param the old page took is carried across.
//
// `from` is what the signed-out bounce's return path was called before it
// became `next`; links minted under that name still carry it (Data
// evolution: a public URL keeps its meaning).
const loginSearchSchema = z.object({
  pendingInviteToken: z.string().min(1).optional(),
  next: returnPathSearchParam,
  from: returnPathSearchParam,
  reason: z.enum(['deactivated_expired', 'restricted']).optional(),
});

export const Route = createFileRoute('/auth/login')({
  validateSearch: loginSearchSchema.parse,
  beforeLoad: ({ search }) => {
    const next = search.next ?? search.from;
    throw redirect({
      to: '/sign-in',
      search: {
        ...(search.pendingInviteToken !== undefined
          ? { pendingInviteToken: search.pendingInviteToken }
          : {}),
        ...(search.reason !== undefined ? { reason: search.reason } : {}),
        ...(next !== undefined ? { next } : {}),
      },
      replace: true,
    });
  },
});
